import { createReducer } from '@reduxjs/toolkit';
var initialState = {
    isSignedIn: undefined,
};
export default createReducer(initialState, {
    'auth/signIn': function (_, action) {
        return action.payload;
    },
    'user/isModerator': function (s) {
        s.isModerator = true;
    },
    'auth/signOut': function () {
        return { isSignedIn: false };
    },
});
